module.exports = {
  "level1": {
    "name": "실제 이름",
    "address": "현재 거주 주소",
    "bank_number": "은행 계좌",
    "wc": "확인",
    "name_nodata": "이름은 비워둘 수 없습니다",
    "id_card_nodata": "ID 번호는 비워둘 수 없습니다",
    "address_nodata": "주소는 비워둘 수 없습니다",
    "bank_number_nodata": "은행 계좌는 비워둘 수 없습니다",
    "input-username": "실제 이름을 입력해 주십시오",
    "zjhm": "ID 번호",
    "input-idcard": "ID 번호를 입력해 주십시오",
    "input-address": "주소를 입력해 주십시오",
    "zjlx": "유효한 신분증(ID) 유형",
    "qxzzjlx": "ID 유형을 선택해 주십시오",
    "sfz": "ID 카드",
    "hz": "여권",
    "jsz": "운전면허증",
    "khh": "계좌 개설",
    "qsrkhh": "은행에 들어가주세요",
    "yhkh": "은행 계좌",
    "qsryhkh": "은행 계좌 번호를 입력해 주십시오",
    "gjlb": "목록 국가 목록",
    "qxzgjlb": "국가 / 지역을 선택하십시오"
  },
  "my": {
    "mqrcode": "내 QR 코드",
    "as": "설정",
    "pc": "주니어 자격증",
    "ac": "시니어 자격증",
    "ms": "공유",
    "me": "내 수입",
    "zsr": "총 수입",
    "mp": "내 프로모션",
    "yqhy": "친구 초대",
    "ar": "기록",
    "hc": "헬프 센터",
    "nodata": "데이터가 없습니다",
    "med": "소득 구분",
    "aes": "누적 소득(USDT)",
    "one": "1세대     ",
    "two": "2세대",
    "three": "3세대",
    "four": "4세대",
    "ones": "1세대 인원",
    "twos": "2세대 인원",
    "threes": "3세대 인원",
    "fours": "4세대 인원",
    "promotion": "프로모션 횟수",
    "customers": "내 수입",
    "wdzc": "내 자산",
    "wdzc1": "내 자산",
    "wyfx": "공유",
    "wdsy": "내 수입",
    "wdtg": "내 프로모션",
    "zhjl": "기록",
    "zxkf": "문의하기",
    "wdxx": "내 메시지",
    "smrz":"KYC 인증",
    "sfyz":"KYC 인증"
  },
  "footer": {
    "home": "홈",
    "quotation": "시장",
    "currency": "교환",
    "lever": "계약",
    "my": "계정",
    "lc": "USDT 이자 소득"
  },
  "index": {
    "wdzc": "내 자산(USDT)",
    "dl": "로그인",
    "zxkf": "문의하기",
    "increase": "이득 목록",
    "usercenter": "개인 센터",
    "security": "보안 센터",
    "address": "인출 주소",
    "aboutus": "회사 소개",
    "vol": "24시간 볼륨",
    "kjcb": "예치",
    "zcbz": "BTC, USDT...",
    "logout":"로그 아웃",
    "language":"언어"
  },
  "transaction": {
    "buy": "매입",
    "sell": "매도",
    "pwd": "거래 암호",
    "inputnum": "액수를 입력하십시오",
    "limit": "한계",
    "avaiable": "이용 가능",
    "turnover": "회전율",
    "handicap": "핸디캡",
    "number": "금액",
    "nonumber": "미지급 금액",
    "numbered": "완료된 금액",
    "price": "가격",
    "marketprice": "시장 가격",
    "cancel": "취소",
    "time": "시간",
    "nomore": "더 이상 없음",
    "nodata": "기록이 없음",
    "getmore": "더 많이 불러오기",
    "mycommission": "거래 전체 중단",
    "currentbuy": "현재 주문(매입)",
    "currentsell": "현재 주문(매도)    ",
    "his": "이력(완료)",
    "currency": "통화",
    "option": "작업",
    "wtime": "완료 시간",
    "wnumber": "완료된 수량",
    "wprice": "완료 가격"
  },
  "mk": {
    "high": "하이",
    "low": "로우",
    "vol": "24시간 볼륨",
    "newPrice": "최신 가격",
    "product": "제품",
    "name":"이름",
    "rank": "이득 목록"
  },
  "deals": {
    "issue_time": "배포 시간",
    "issue_number": "발행 번호",
    "white_book": "백서",
    "weburl": "공식 웹사이트",
    "video_url": "비디오",
    "introduction": "정보",
    "onhand": "1로트 =",
    "position": "포지션",
    "leverorder": "레버리지 주문",
    "leverposition": "레버리지 포지션",
    "inputprice": "입력 가격",
    "inputmul": "입력 배수",
    "selectmul": "배수 선택",
    "onehand": "1로트 =",
    "hand": "거래 로트",
    "marketval": "시장 가치",
    "bond": "본드",
    "balance": "잔고",
    "type": "유형",
    "risk": "위험률",
    "total": "총 수익",
    "onekey": "원클릭 환금",
    "makemore": "(롱)",
    "makeless": "(쇼트)",
    "current": "대기 주문",
    "all": "모두",
    "weing": "수수료",
    "tding": "거래",
    "ping": "청산",
    "pied": "청산됨",
    "ceiled": "인출됨",
    "weprice": "커미션 가격",
    "oprice": "개시 가격",
    "nowprice": "현재 가격",
    "zyprice": "수익 가격 취하기",
    "zsprice": "손실 중단 가격",
    "canbond": "이용 가능 마진",
    "optime": "개시 시간",
    "pgtime": "청산 시간",
    "znum": "변환된 금액",
    "gprice": "야간 요금",
    "pcang": "클로즈",
    "revoke": "인출",
    "fee": "수수료",
    "you": "최적 시장 가격"
  },
  "assets": {
    "copy": "복사",
    "avaiable": "이용 가능",
    "lock": "동결",
    "conversion": "전환",
    "exact": "거래 계좌",
    "num": "금액",
    "time": "시간",
    "all": "모두",
    "canuse": "이용 가능",
    "cmoney": "예치",
    "tmoney": "인출",
    "caddress": "예치 주소",
    "copyaddress": "주소 복사",
    "taddress": "인출 주소",
    "taddressm": "인출 주소를 입력해 주십시오",
    "rate": "수수료",
    "dnum": "도착 금액",
    "more": "더 많이 불러오기",
    "nodata": "기록이 없음",
    "yczc": "보유하고 있지 않은 자산 숨기기",
    "total":"자산 전환 (USDT)"
  },
  "td": {
    "drecord": "주문 기록",
    "orecord": "완료된 주문",
    "filter": "필터",
    "dstatus": "주문 상태",
    "nofinish": "취소됨",
    "finished": "완료됨",
    "ceiled": "취소됨",
    "reset": "재설정",
    "confirm": "확인",
    "time": "시간",
    "num": "금액",
    "price": "가격",
    "ptime": "주문 시간",
    "receiver": "수취인",
    "open": "계좌 개설",
    "pwd": "거래 암호",
    "ppwd": "거래 암호를 입력해 주십시오",
    "sure": "확인",
    "realName": "실제 이름",
    "pnum": "금액을 입력해 주십시오",
    "buyNum": "구매 금액",
    "currency": "통화"
  },
  "fat": {
    "ceil": "취소",
    "num": "금액",
    "submit": "주문",
    "pwd": "거래 암호",
    "ppwd": "거래 암호를 입력해 주십시오",
    "sure": "확인",
    "auHigh": "시니어 자격증"
  },
  "auth": {
    "bh": "거부됨",
    "mycenter": "개인 센터",
    "test": "KYC",
    "testing": "검토 중",
    "name": "이름",
    "account": "계정",
    "id_card_face": "신분증의 앞면을 업로드해 주십시오\n",
    "id_card_back": "신분증의 뒷면을 업로드해 주십시오",
    "updata": "제출",
    "updata_again": "다시 제출   "
  },
  "code": {
    "notice": "알림     "
  },
  "safe": {
    "title": "계정 보안   ",
    "center": "보안 센터",
    "yysz": "언어",
    "ssms": "다크 모드   ",
    "gywm": "회사 소개",
    "lgpwd": "로그인 암호 ",
    "resetpwd": "암호 수정",
    "paccount": "휴대폰 번호 또는 메일박스",
    "reset": "수정",
    "ceil": "취소",
    "pcode": "확인 코드",
    "sure": "확인",
    "newPwd": "암호 재설정",
    "ppwd": "암호",
    "reppwd": "암호 다시 입력",
    "repwd": "암호 재설정",
    "zpwd": "거래 암호"
  },
  "met": {
    "open": "은행 계좌 명의자 이름",
    "bank": "은행 계좌",
    "realname": "실제 이름",
    "save": "저장",
    "popen": "은행 계좌 명의자 이름을 입력해 주십시오",
    "pbank": "계좌 번호를 입력해 주십시오",
    "pname": "실제 이름을 입력해 주십시오"
  },
  "ads": {
    "tas": "인출 주소",
    "address": "주소",
    "noads": "아직 주소가 없습니다.",
    "adds": "주소",
    "remark": "비고",
    "cel": "삭제"
  },
  "jc": {
    "ppwd": "암호"
  },
  "lg": {
    "welcome": "환영합니다! 로그인해주십시오",
    "lgtel": "모바일 로그인",
    "lgeml": "이메일 로그인",
    "paccount": "전화번호 또는 이메일",
    "ppwd": "암호",
    "ppwd2": "암호를 확인해 주십시오",
    "pcode": "확인 코드",
    "qsryqm": "초대 코드",
    "noaccount": "아직 계정이 없습니까?",
    "register": "등록",
    "phregister": "모바일 등록",
    "emregister": "이메일 등록",
    "pphone": "휴대 전화 번호",
    "ceil": "취소",
    "send": "CAPTCHA 받기",
    "sure": "확인",
    "email": "이메일 주소",
    "emtest": "이메일 확인",
    "pemcode": "확인 코드",
    "ppcode": "확인 코드를 입력해 주십시오",
    "ftpwd": "암호를 잊으셨습니까?",
    "ptext": "휴대폰 번호 또는 메일박스",
    "yzm": "확인 코드",
    "mm": "암호",
    "qrmm": "암호 확인",
    "language":"언어",
    "qregister":"등록",
    "lgs":"로그인",
    "ftpwds":"암호를 잊으셨습니까",
    "kjzc": "빠른 등록을 위해 저희에게 연락하십시오",
    "kjzc1": "보안문자를 받을 수 없나요?",
    "kjzc3": "빠른 등록",
    "wyzx": "나는 이미 알고있다",
    "qtxyxzh": "중요한: 비밀번호를 찾는 데 사용할 수 있는 유효한 이메일 주소 또는 휴대폰 번호를 입력하세요.",
    "next": "다음 단계"
  },
  "gjrz": {
    "title": "시니어 자격증",
    "t1": "1. 8MB보다 작은 크기의 JPG JPEG 또는 PNG 포맷의 이미지들이 지원됩니다.",
    "t2": "2. ID 문서 사진은 선명해야 하고 수정되거나 가려져서는 안 됩니다. 개인 사진 문서 번호와 문서 보유자의 이름이 선명하게 드러나야 합니다.",
    "t3": "3. 사진은 모자를 쓰지 않은 상태로 촬영되어야 하고 화장을 하지 말 것을 권장합니다. 사진의 안면 기능들이 선명하고 알아볼 수 있어야 하며, 팔이 안전히 노출되어야 합니다.",
    "t4": "확인",
    "bh": "거부됨",
    "shz": "검토 중",
    "shtg": "승인됨",
    "sczjz": "ID 사진 업로드",
    "sczjzmz": "ID 문서의 앞면 사진 업로드",
    "sczjbmz": "ID 문서의 뒷면 사진 업로드",
    "scgrqmz": "ID 문서 및 개인 서명 업로드"
  },
  "chongzhi": {
    "title": "예치",
    "cbjl": "예치 기록",
    "t1": "금액",
    "t2": "금액을 입력해 주십시오",
    "t3": "바우처 설명(선택 과목)",
    "t4": "설명을 입력해 주십시오",
    "t5": "바우처 이미지",
    "t6": "확인",
    "t7": "체인 이름",
    "t8": "QR 코드",
    "t9": "QR 코드 저장",
    "t10": "예치 주소",
    "t11": "복사",
    "zy": "중요한",
    "tips1": "현재 통화가 아닌 자산들은 위 주소로 충전하지 말아 주십시오. 그렇지 않으면 해당 자산을 조회할 수 없습니다",
    "tips2": "1. 지갑/플랫폼 호환성: 즉, 네트워크가 지원되며 대상 플랫폼이 출금 네트워크를 지원하지 않는 경우 자산을 검색할 수 없습니다.",
    "tips3": "2. 귀하의 탑업 네트워크와 대상 플랫폼이 동일하며, 대상 주소를 이더리움 네트워크로 선택했지만 탑업이 TRC20 스마트체인을 선택한 경우 디지털 자산을 검색하지 못할 수 있습니다.",
    "tips4": "3. 충전하기 전에 주소와 금액이 정확한지 확인하십시오.",
    "tips5": "알림: 블록 네트워크의 익명성과 개인 정보 보호로 인해 잘못된 정보를 입력하면 해당 자산을 잃게 됩니다. 충전 주소와 수량을 잘 확인하세요."
  },
  "tibi": {
    "title": "철회하다",
    "tbjl": "인출 기록",
    "t1": "인출 주소",
    "t2": "인출 주소를 입력해 주십시오",
    "t3": "인출 수량",
    "qsrtbsl": "인출 통화의 수량을 입력해 주십시오",
    "t4": "최소",
    "t5": "거래 암호",
    "t6": "거래 암호를 입력해 주십시오",
    "t7": "요금",
    "t8": "도착 금액",
    "t9": "확인",
    "sc": "삭제",
    "bj": "편집",
    "bq": "태그 (메모)",
    "qsrbq": "태그를 입력해 주십시오",
    "yhktx": "은행 카드 인출",
    "yhmc": "은행 이름",
    "qsryhmc": "은행 이름을 입력해 주십시오",
    "yhzh": "은행 계좌",
    "qsryhzh": "은행 계좌를 입력해 주십시오",
    "gjhkdm": "SWIFT 코드",
    "qsrgjhkdm": "SWIFT 코드를 입력해 주십시오",
    "yhdz": "은행 주소",
    "qsryhdz": "은행 주소를 입력해 주십시오",
    "skrxm": "수취인 이름",
    "qsrskrxm": "수취인 이름을 입력해 주십시오",
    "skrdh": "수취인 전화",
    "qsrskrdh": "수취인 전화를 입력해 주십시오",
    "skrdz": "수취인 주소",
    "qsrskrdz": "수취인 주소를 입력해 주십시오"
  },
  "huazhuan": {
    "t4": "금액을 입력해 주십시오",
    "ky": "이용 가능",
    "t10": "확인"
  },
  "banner": {
    "title": "상세 정보"
  },
  "download": {
    "t1": "거래, 어디서나",
    "xz": "다운로드"
  },
  "xgdlmm": {
    "title": "로그인 암호 수정",
    "zh": "계정",
    "yzm": "확인 코드",
    "yzmts": "확인 코드",
    "hqyzm": "CAPTCHA 받기",
    "mm": "암호",
    "qrmm": "암호 확인",
    "qr": "확인",
    "zhts":"휴대전화 또는 이메일",
    "mmts":"암호 길이 6-12자 알파벳과 숫자 조합"
  },
  "sztkmm": {
    "title": "인출 암호 설정",
    "dlmm": "로그인 암호 ",
    "dlmmts": "로그인 암호를 입력해 주십시오",
    "xmm": "새 암호",
    "mmts": "암호 길이 6자리",
    "qrmm": "암호 확인",
    "qr": "확인",
    "qd": "확인",
    "sztkts": "팁: 거래 암호를 설정하려면 보안 센터로 이동해 주십시오"
  },
  "rule": {
    "title": "이벤트 규칙",
    "title2": "규칙",
    "title3": "이벤트"
  },
  "news": {
    "title": "내 메시지",
    "ckxq": "상세 정보 보기",
    "gg": "알림"
  },
  "search": {
    "qx": "취소"
  },
  "wdtg": {
    "wdyqlj": "내 초대 링크",
    "wdyqm": "내 초대 코드",
    "schbyq": "포스터 초대 생성",
    "ljtgsy": "총 수입",
    "tkrs": "초대 수",
    "ljyj": "누적 커미션",
    "yjmx": "커미션 상세 정보",
    "ljyjjl": "누적 커미션 상금(USDT)",
    "ljsy": "총 수입",
    "ljyqjl": "누적 초대 상금(USTD)",
    "fxd": "공유 대상:",
    "bctp": "사진 저장",
    "qx": "취소",
    "t3": "이미지를 식별하거나 스캔하십시오"
  },
  "bzhl": {
    "title": "AI 돈을 얻다",
    "gz": "규칙",
    "tgdd": "에스크로 주문",
    "zztgdzj": "보호 예수 자금",
    "yjjrsy": "오늘의 수입",
    "ljsy": "총 수입",
    "tgzdd": "보호 예수 주문",
    "cljxcp": "전략적 광고 상품",
    "dbxe": "단일 한도",
    "rsyl": "일일 수익률",
    "zq": "주기",
    "qmr": "지금 매입",
    "bbzhzc": "계좌 자산",
    "dd": "주문",
    "buy": "매입",
    "jxcp": "주요 상품",
    "ckdd": "주문 확인",
    "gd": "더 보기",
    "xzbzts": "간단하고 안전합니다. 배당금은 여러 통화로 선택할 수 있습니다.",
    "qtbz": "기타 동전"
  },
  "bzhlgm": {
    "qtzq": "USDT 7일 주기",
    "rsyl": "일일 수익률",
    "lczq": "재무적 주기",
    "dbxe": "단일 한도",
    "pxsj": "배당금 지급 시기",
    "mr": "매일",
    "dqfh": "기한 만료 시 반환",
    "tgzj": "보호 예수 자본",
    "tqsh": "조기 상환",
    "yjsy": "예상 수입(USDT)",
    "kyzc": "이용 가능 자산(USDT)",
    "cpjs": "상품 소개",
    "tgje": "보호 예수 금액",
    "qsrtgje": "보호 예수 금액을 입력해 주십시오",
    "qb": "모두",
    "rm": "지금 매입",
    "cpzq": "상품 주기",
    "gz": "규칙과 이자를 알아 두기"
  },
  "bzhlwdtg": {
    "title": "주문 상태",
    "tgz": "보호 예수 중",
    "ywc": "완료됨",
    "ysh": "상환됨",
    "tgje": "보호 예수 금액/보호 예수 시간",
    "rsyl": "일일 수익률",
    "yhl": "수익:",
    "xdsj": "주문 시간",
    "sh": "상환",
    "ddxq": "주문 상세 정보",
    "ddh": "주문 번호"
  },
  "bzjj": {
    "t1": "날마다 수익을 올리세요",
    "cpld": "상품 하이라이트",
    "scsq": "언제라도 예치하고 받으세요",
    "pxzq": "배당금 주기",
    "mtxf": "매일 배분",
    "hqlx": "현재 이자",
    "zj": "100% 펀딩",
    "aqbz": "보안",
    "jjrsy": "공휴일 수입",
    "sybjd": "지속적인 이익",
    "bjd": "무중단",
    "cgcrh": "성공적인 예치 후",
    "dtqx": "오늘의 이자 가치",
    "jglz": "예",
    "syjs": "총 수입 계산",
    "cont2": "최소: 10000U x 0.3%=30U",
    "cont3": "최대: 10000U x 0.5%=50U",
    "gywyj": "확정손해 배상액 안내",
    "wycy": "가입하고 싶습니다"
  },
  "zyzs": {
    "title": "수익을 올리고 손실은 멈추세요",
    "zy": "수익 올리기",
    "zs": "손실 멈추기",
    "qsrzyjg": "수익 올리기 가격을 입력해 주십시오",
    "qsrzsjg": "손실 멈추기 가격을 입력해 주십시오",
    "scjg": "시장 가격",
    "wxts": "미리 알림:",
    "qr": "확인"
  },
  "bbjy": {
    "mr": "매입",
    "mc": "매도",
    "mai": "매입",
    "sell": "매도",
    "xj": "한계",
    "sj": "시장 가격",
    "pk": "핸디캡",
    "jg": "가격",
    "sl": "금액",
    "mrl": "매입량",
    "ss": "금액",
    "mcl": "매도량",
    "ky": "이용 가능",
    "km": "이용 가능",
    "ksell": "판매 가능",
    "jye": "회전율",
    "dqwt": "대기 주문",
    "lswt": "커미션 이력",
    "jj": "정보",
    "wtzl": "총",
    "wtjg": "커미션 가격",
    "ycjl": "완료된 거래 볼륨",
    "cjjj": "평균 거래 가격",
    "cd": "인출",
    "xd": "주문",
    "ywc": "완료됨",
    "ycd": "인출됨",
    "wqcj": "거래 완료",
    "zx": "선택 사항",
    "scjg": "시장 가격",
    "fhsj": "배포 시간",
    "fhsl": "발행 번호",
    "bps": "백서",
    "gw": "공식 웹사이트",
    "qx": "취소"
  },
  "hyjy": {
    "mai": "매입",
    "sell": "매도",
    "kc": "오픈 포지션",
    "pc": "클로즈",
    "cc": "포지션",
    "kp": "클로즈",
    "kpc": "클로즈 쇼트",
    "kcc": "포지션",
    "kkd": "오픈 롱",
    "kpd": "롱 클로즈",
    "kkk": "오픈 쇼트",
    "xj": "한계",
    "sj": "시장 가격",
    "xjwt": "주문 제한",
    "sjwt": "시장 가격",
    "pk": "핸디캡",
    "jg": "가격",
    "sl": "금액",
    "gg": "레버리지",
    "tzgg": "레버리지 조정",
    "ggbs": "레버리지",
    "mrl": "매입량",
    "ky": "이용 가능",
    "jye": "회전율",
    "dqwt": "대기 주문",
    "lswt": "커미션 이력",
    "ptwt": "통상 커미션",
    "dqwtmr": "현재 주문(매입)",
    "dqwtmc": "현재 주문(매도)    ",
    "hywt": "계약 커미션",
    "jj": "정보",
    "wtzl": "총",
    "wtjg": "커미션 가격",
    "ycjl": "완료된 거래 볼륨",
    "cjjj": "평균 거래 가격",
    "cd": "인출",
    "xd": "주문",
    "wqcj": "거래 완료",
    "ywc": "완료됨",
    "ycd": "인출됨",
    "zx": "선택 사항",
    "scjg": "시장 가격",
    "fhsj": "배포 시간",
    "fhsl": "발행 번호",
    "bps": "백서",
    "gw": "공식 웹사이트",
    "mrzd": "롱 매입",
    "mrpk": "쇼트 매입 ",
    "mczk": "쇼트 매도 ",
    "mcpd": "롱 매도",
    "mrkdkz": "오픈 매입(상승세)",
    "mrpkkz": "클로즈 매입(상승세)",
    "mckkkd": "오픈 매입(하락세)",
    "mcpdkd": "클로즈 매도(하락세)",
    "yxhy": "영구 계약",
    "dc": "롱 포지션",
    "syl": "수익률",
    "bzjl": "마진율",
    "tzbzj": "마진 조정",
    "zyzs": "수익을 올리고 손실은 멈추세요",
    "zhang": "금액",
    "qblx": "모든 유형",
    "qb": "모두",
    "ccjg": "포지션 가격",
    "ccsl": "포지션 수량",
    "yk": "수익 및 손실",
    "ccsj": "포지션 시간",
    "zy": "수익 올리기",
    "zs": "손실 멈추기",
    "zje": "총 금액",
    "kcs": "오픈 포지션 수량",
    "kcjg": "오픈 포지션 가격",
    "ss": "로트",
    "hand": "1 로트  =",
    "qx": "취소",
    "qr": "확인",
    "qbcd":"모든 주문 취소"
  },
  "kxt": {
    "gao":"H",
    "di":"L",
    "wtgd": "보류 중 주문",
    "cj": "딜",
    "jj": "정보",
    "sj": "시간",
    "fx": "방향",
    "jg": "가격",
    "sl": "금액",
    "mr": "매입",
    "mc": "매도",
    "mp": "입찰",
    "sp": "매도 중",
    "slb": "금액",
    "fhsj": "배포 시간",
    "fhsl": "발행 번호",
    "bps": "백서",
    "gw": "공식 웹사이트",
    "fz":"min",
    "xs":"hour",
    "tian":"day",
    "zhou":"week",
    "yue":"month",
    "gd": "More",
    "ft": "측면 사진",
    "zt": "메인 사진",
    "sdt": "깊이",
    "zx": "선택 사항",
    "djck": "보려면 클릭"
  },
  "zhjl": {
    "cbtb": "예치 및 인출",
    "jymx": "거래 상세 정보",
    "tgyj": "프로모션 커미션",
    "wwc": "취소됨",
    "ywc": "완료됨"
  },
  "zwsj": {
    "title": "데이터가 없습니다"
  },
  "bzxz": {
    "title": "통화 선택"
  },
  "jghy": {
    "jghy": "선물",
    "yxhy": "빈번한",
    "mz": "강세",
    "md": "약세",
    "gmj": "구매가",
    "jsj": "정산가",
    "xj": "현재 가격",
    "fx": "방향",
    "sl": "금액",
    "jgsj": "배송 시간",
    "gb": "클로즈",
    "jxxd": "계속 주문",
    "cclb": "주문 목록",
    "zc": "현재",
    "lscc": "이력",
    "qblx": "모든 유형",
    "yk": "수익 및 손실",
    "ddqr": "주문 확인",
    "dqsj": "만료 시간",
    "jssj": "배송 시간",
    "sy": "수익",
    "tzje": "투자 가격",
    "zdje": "최저 가격 0",
    "kyye": "균형: ",
    "kyye2": "균형",
    "sxf": "요금: ",
    "sxfl": "요금",
    "jypz": "이름",
    "jyfx": "방향",
    "qrxd": "확인",
    "dqye": "현재 잔고"
  },
  "kjmb": {
    "title": "암호화폐",
    "gm": "USDT 매입",
    "wxts": "미리 알림:",
    "copy": "복사",
    "ljmb": "암호 화폐 구매",
    "qx": "취소",
    "gmsl": "구매 금액",
    "cssl": "매도 금액",
    "qsrgmsl": "구매 금액을 입력해 주십시오",
    "qsrcssl": "판매 금액을 입력해 주십시오",
    "jg": "가격",
    "fzcg": "성공적으로 복사"
  },
  "tips": {
    "jymm": "거래 암호",
    "szjymm": "인출 암호 설정",
    "qsrjymm": "거래 암호를 입력해 주십시오",
    "jymmts": "거래 암호를 설정하려면 보안 센터로 이동해 주십시오"
  },
  "xyf":{
    "title": "신용 점수",
    "pgsj": "평가 시간"
  },
  "dzrz":{
    "title": "주소 인증",
    "sdddz":"공과금 청구서 주소",
    "tpsc": "빌 이미지 업로드",
    "ts": "알림 : 당신은 주소 정보를 입력하고, 공공 요금 또는 광대역 주소 법안을 제출해야",
    "tips":"당신은 주소 정보를 입력하고, 공공 요금 또는 광대역 주소 법안을 제출해야",
    "qsczdtp":"빌 이미지 업로드"
  },
  "newReg":{
    "sjh": "휴대전화",
    "yx": "이메일",
    "yqm": "초대 코드",
    "yqm2": "초대 코드(선택 사항)",
    "cjzh": "계정 만들기",
    "sysjhzyx": "휴대폰 번호/이메일로 등록",
    "sj": "휴대전화",
    "yhxy": "&lt;이용약관&gt;",
    "yhxy2": "및 &lt;이용약관&gt;을 읽었으며 이에 동의합니다."
  },
  "mbwt":{
    "title": "보안 문제 설정",
    "mbwt": "보안 문제들",
    "qtxda": "답변을 작성해주세요",
    "qsrxmm": "새 비밀번호를 입력하세요",
    "sydqmmcz": "현재 비밀번호 재설정 사용",
    "zhmm": "보안 문제 비밀번호 검색",
    "ysz": "설정되었습니다",
    "tg": "뛰어 넘다",
    "tj": "제출하다",
    "zyts": "중요한:",
    "zytsCont": "비밀번호와 인증번호를 공개하지 마시고, 비밀번호 찾기에 도움이 되는 보안 문제를 염두에 두시기 바랍니다."
  },
  "xbsg":{
    "title": "뉴코인존",
    "wdsg": "세부",
    "scts": "락업일: ",
    "sy": "남은",
    "ljsg": "지금 구독",
    "ysk": "매진",
    "xzjdy": "지금 구독",
    "dy": "구독하다",
    "fxjg": "발행 가격",
    "fxl": "순환",
    "ssrq": "상장일",
    "yxqx": "유효 기간",
    "qsrsl": "수량을 입력해주세요",
    "syl": "남은",
    "sgrq": "구독 날짜",
    "sgsl": "양",
    "bz": "동전",
    "yebz": "USDT 잔액 부족",
    "tgsl": "패스 수량",
    "shz": "검토 중",
    "wtg": "실패",
    "ytg": "통과"
  },
  "wydb":{
    "title": "빌리다",
    "db": "빌리다",
    "dbz": "빌리다",
    "jl": "기록",
    "jdzq": "기간(일)",
    "qhk": "갚다",
    "ljdb": "누적(usdt)",
    "dhkbs" :"지불 보류",
    "jkje": "대출금액(usdt)",
    "qsrje": "수량을 입력해주세요",
    "rll": "일일 이자율",
    "hkfs": "반환",
    "dqych": "만료됨",
    "lx": "관심",
    "fkjg": "대주",
    "tpsc": "신용대출(이미지 업로드)",
    "fwxx": "주택정보",
    "srzm": "소득 증명(고용 관계)",
    "yhmx": "은행 명세서",
    "zjz": "신분증 사진",
    "yd": "읽고 동의했습니다",
    "xy": "대출 계약 신청",
    "sqdb": "대출 체인 신청",
    "gb": "폐쇄",
    "qd": "확인",
    "ts": "대출 계약 신청을 확인하십시오",
    "dbjl": "기록",
    "hkhth": "주문 코드",
    "wsh": "미검토",
    "yfk": "대출",
    "sqrq": "신청 시간",
    "zq": "주기",
    "dbsl": "갈비뼈의 수",
    "zhke": "총 지불",
    "yhkxq": "상환내역",
    "bqyhk": "현재 기간에 상환 가능(USDT)",
    "hktips": "잔액이 충분한지 확인하시고, 잔액이 부족할 경우 충전 후 상환하시기 바랍니다.",
    "bj": "주요한",
    "jie": "빌리다",
    "ljhk": "즉시 상환",
    "qcz": "입금하기",
    "yebzqxcz": "잔액이 부족합니다. 먼저 충전한 다음 상환하세요.",
    "znj": "연체료",
    "yqts": "연체일수"
  },
  "hkxq":{
    "dd":"주문하다",
    "fzhkdz":"상환 주소 복사",
    "hkxq": "상환내역",
    "zlx": "총 이자",
    "zhk": "총 상환액",
    "hkjg": "상환 기관",
    "qschkpz": "상환 증명서를 업로드하십시오",
    "hkpz": "상환 증명서"
  },
  "bbjyNew":{
    "jylx": "유형",
    "jyze": "양"
  },
  "indexNew":{
    "title": "기본 인터페이스에 Spmaxex 추가",
    "t1": "전체 화면 경험에 대한 빠른 액세스",
    "t2": "아래 도구 모음을 클릭하십시오.",
    "t3": "그리고 선택",
    "t4": "홈 화면에 추가",
    "t5": "Spmaxex의 데스크톱 경험 정식 버전에 추가",
    "t6": "즐겨 찾기에 추가",
    "t7": "페이지에서 찾기"
  },
  "bind":{
    "title": "우편",
    "ybd": "경계",
    "wbd": "매여 있지 않은",
    "yrz": "확인됨",
    "wrz": "확인되지 않음",
    "ts": "계정을 보호하려면 이메일 주소를 묶는 것이 좋습니다.",
    "qsryxdz": "이메일 주소"
  },
  "status":{
    "statusText": ['실패','처리 대기 중','성공'],
 },
 "tipsNew":{
   "wjmmts": "인증 코드로 비밀번호 복구",
   "qscpztp": "바우처 이미지 업로드",
   "emailgsts": "유효한 이메일을 입력하십시오",
   "telgsts": "휴대폰 번호가 잘못되었습니다",
   "lcmmbyz": "비밀번호를 확인해주세요",
   "zdsl": "최소 수량 ",
   "sldydy": "다음보다 크거나 같은 수량",
   "zxtzsl": "최소 수량 ",
   "ddz": "기다리는",
   "xs": "시간",
   "min": "최소 금액 ",
   "max": "최대 금액 ",
   "yebz": "잔액 불충분",
   "qsrss": "로트를 입력하세요",
   "zdss": "최소 부지",
   "yjj": "거부",
   "shz": "구원",
   "zwkfcz": "이 통화는 아직 충전할 수 없습니다.",
   "jiaoge": "배달",
    "zhang": "일어나다",
    "die": "죽다",
    "cjxnzh": "가상 계정 만들기"
 },
 "langNew2":{
  "flzq": "보상 허브",
  "qdjl": "로그인 보상",
  "mrqdjl": "일일 로그인 보상",
  "qd": "로그인",
  "yqd": "로그인",
  "hdgz": "이벤트 규칙",
  "qdjl2": "체크인 기록",
  "qdcg": "성공적으로 로그인",
  "yhd": "획득",
  "lq": "수신",
  "dyt": "1일차",
  "det": "2일차",
  "dst": "3일차",
  "dsit": "4일차",
  "dwt": "5일차",
  "dlt": "6일차",
  "dqt": "7일차",
  "jxz": "진행 중"
},
"langNew":{
  "kp": "열리는",
  "zuoshou": "어제 받음",
  "zg": "제일 높은",
  "zd": "최저",
  "dqjg": "현재 가격",
  "pcjg": "종가",
  "gd": "미결 주문",
  "gdj": "보류 중인 주문 가격",
  "gdjg": "보류 중인 주문 가격",
  "xfbzj": "필요한 보증금: ",
  "ksrfw": "사용 가능한 입력 범위: ",
  "shou": "많이",
  "fdjyk": "유동 순이익 및 손실",
  "pcsl": "결산 수량",
  "cx": "취소",
  "qrpc": "포지션 청산 확인",
  "sx": "필터",
  "cz": "초기화",
  "zdl": "알고 있었다",
  "kccg": "성공적으로 포지션을 열었습니다!",
  "xzfx": "방향을 선택",
  "lx": "유형",
  "xgcc": "위치 수정",
  "szzyzs": "손절매 및 손절매 설정",
  "szhb": "암호화폐",
  "gjs": "금속",
  "yy": "조잡한",
  "jy": "거래",
  "jmhb": "암호화폐",
  "gdsj": "주문 대기 시간",
  "gdsl": "보류 중인 주문 수량",
  "fs": "time",
  "qbdl": "지갑 로그인",
  "qbdlts": "지갑 브라우저를 사용하여 접속하고 로그인하세요.",
  "tcmnzh": "가상계좌 로그아웃",
  "bc": "커버 위치",
  "qdlzszh":"충전하려면 실제 계정으로 로그인하세요.",
  "ts": "즉각적인",
  "czsqytj": "재충전 신청서가 제출되었습니다.",
  "czdzts": "충전신청을 했는데 충전이 접수되지 않나요?",
  "fhsy": "홈페이지로 돌아가기",
  "je": "양",
  "zdje": "최소 금액 ",
  "zdje2": "최대 금액 "
 }
}



// WEBPACK FOOTER //
// ./src/utils/lang/kr.js